<template>
  <div class="runtime-log-page">
    <div class="runtime-log-card">
      <div class="toolbar">
        <div>
          <div class="page-title">全局运行日志</div>
          <div class="page-subtitle">项目运行时输出、后台任务和接口异常，默认展示最新 100 条</div>
        </div>
        <div class="toolbar-actions">
          <el-select v-model="range" style="width: 140px" @change="getLogs">
            <el-option label="最新100条" value="latest"></el-option>
            <el-option label="全部日志" value="all"></el-option>
          </el-select>
          <el-input
            v-model="keyword"
            clearable
            placeholder="搜索来源或内容"
            prefix-icon="el-icon-search"
            style="width: 220px"
            @keyup.enter.native="getLogs"
            @clear="getLogs"
          ></el-input>
          <el-select v-model="level" clearable placeholder="级别" style="width: 120px" @change="getLogs">
            <el-option label="info" value="info"></el-option>
            <el-option label="warning" value="warning"></el-option>
            <el-option label="error" value="error"></el-option>
          </el-select>
          <el-button icon="el-icon-refresh" @click="getLogs">刷新</el-button>
        </div>
      </div>

      <el-table :data="list" height="76vh" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="时间" width="170">
          <template slot-scope="scope">{{ scope.row.time_text || formatTime(scope.row.time) }}</template>
        </el-table-column>
        <el-table-column label="级别" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="levelType(scope.row.level)">{{ scope.row.level }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源" width="130"></el-table-column>
        <el-table-column prop="message" label="内容" min-width="520" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="运行日志详情" :visible.sync="visible" width="760px">
      <pre class="detail-pre">{{ detail }}</pre>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess, prettyJson } from "./appAdminUtils.js";

export default {
  name: "runtimeLogs",
  data() {
    return {
      list: [],
      level: "",
      keyword: "",
      range: "latest",
      visible: false,
      detail: "",
    };
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    formatTime,
    getLogs() {
      post("/api/admin/runtime/logs", {
        size: this.range === "all" ? 1000 : 100,
        all: this.range === "all",
        level: this.level,
        keyword: this.keyword,
      }).then((res) => {
        if (isSuccess(res)) {
          this.list = (res.data.data && res.data.data.data) || [];
        } else {
          this.$message.error(res.data.msg || "日志获取失败");
        }
      });
    },
    levelType(level) {
      if (level === "error") return "danger";
      if (level === "warning") return "warning";
      return "success";
    },
    openDetail(row) {
      this.detail = prettyJson(row);
      this.visible = true;
    },
  },
};
</script>

<style scoped>
.runtime-log-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.runtime-log-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.toolbar-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}
.page-title {
  font-size: 22px;
  color: #1f2d3d;
  font-weight: 700;
}
.page-subtitle {
  margin-top: 6px;
  color: #7f8fa4;
  font-size: 13px;
}
.detail-pre {
  max-height: 64vh;
  padding: 14px;
  background: #f7fafc;
  border-radius: 6px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
